import {
    AgileOverviewRelayOneQuery,
    getAgileOverviewRelayQueryVars
} from "@/contentful/graphql";
import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import { init as initRelay } from "../init-relay";
import { AgileOverviewPageRelay } from "../pages/agile/overview/agile-overview-page-relay";

initRelay(
    AgileOverviewPageRelay,
    AgileOverviewRelayOneQuery,
    getAgileOverviewRelayQueryVars(window.location),
    RELAY_API_CONTENTFUL
);
